import { Pipe, PipeTransform } from '@angular/core';
import Decimal from 'decimal.js';

@Pipe({
  name: 'quarterFloor',
  standalone: true,
  pure: true,
})
export class QuarterFloorPipe implements PipeTransform {
  transform(balance: number | Decimal): number {
    if (balance instanceof Decimal) {
      balance = balance.toNumber();
    }
    if (balance == null || isNaN(balance)) {
      return 0;
    }

    return Math.floor(balance) + Math.floor((balance % 1) / 0.25) * 0.25;
  }
}
